import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle, Windows } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";

import n21 from "../assets/projects/n21.jpeg";
import n22 from "../assets/projects/n22-min.jpeg";
// import n25 from "../assets/projects/n25-min.png";
// import n26 from "../assets/projects/n26-min.jpeg";
// import n27 from "../assets/projects/n27-min.png";
import n29 from "../assets/projects/n29-min.jpeg";
import n30 from "../assets/projects/n30-min.jpeg";
import n31 from "../assets/projects/n31-min.jpeg";
import n28 from "../assets/projects/n28-min.jpeg";



import {
  FaReact,
  FaHtml5,
  FaCss3Alt,
  FaNodeJs,
  FaGithub,
  FaApple,
} from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io5";
import { DiMongodb } from "react-icons/di";
import { SiNestjs } from "react-icons/si";
import { BsAndroid2 } from "react-icons/bs";
import { RiExternalLinkFill } from "react-icons/ri";
import { MdOutlinePreview } from "react-icons/md";
import { LazyLoadedImage } from "./LazyLoadImage";

export const ProjectsNew = () => {
  return (
    <section className="projectsNew">
      <Container>
        <div className="row">
          <h1 className="featured-head">Projects</h1>
        </div>
        <Row>
          {/* Project 1: Car Rental */}
          <Col xs={6} sm={6} md={4} xl={4} className=" divImage">
            <Row>
              <h6>Algavenice</h6>
            </Row>
            <a
              href="https://algavenice.com/en/"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <div class="imageContainer">
                <LazyLoadedImage src={n21} alt="Description" />
              </div>
            </a>
            <div className="detailIconDiv">
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    style={{ textDecoration: "none" }}
                    
                    target="_blank"
                  >
                    <FaGithub
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    PRIVATE
                  </a>
                )}
              </TrackVisibility>
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    style={{ textDecoration: "none" }}
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    href="https://algavenice.com/en/"
                    target="_blank"
                  >
                    <RiExternalLinkFill
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    PREVIEW
                  </a>
                )}
              </TrackVisibility>
            </div>
          </Col>

          {/* Project 2: Gymate */}
          <Col xs={6} sm={6} md={4} xl={4} className=" divImage">
            <Row>
              <h6>Sportskred's</h6>
            </Row>
            <a
              href="https://sportskred.com/"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <div class="imageContainer">
                <LazyLoadedImage src={n29} alt="Description" />
              </div>
            </a>
            <div className="detailIconDiv">
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    style={{ textDecoration: "none" }}
                    // href="https://github.com/Sumair10/Gymtae"
                    target="_blank"
                  >
                    <FaGithub
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    PRIVATE
                  </a>
                )}
              </TrackVisibility>
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    style={{ textDecoration: "none" }}
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    href="https://sportskred.com/"
                    target="_blank"
                  >
                    <RiExternalLinkFill
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    PREVIEW
                  </a>
                )}
              </TrackVisibility>
            </div>
          </Col>

          {/* Project 3: Minimalist */}
          <Col xs={6} sm={6} md={4} xl={4} className=" divImage">
            <Row>
              <h6>My Property Listing</h6>
            </Row>
            <a
              href="https://www.mypropertylisting.co.uk/"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <div class="imageContainer">
                <LazyLoadedImage src={n22} alt="Description" />
              </div>
            </a>
            <div className="detailIconDiv">
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    // href="https://github.com/Sumair10/e-tech-commerce"
                    style={{ textDecoration: "none" }}
                    target="_blank"
                  >
                    <FaGithub
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    PRIVATE
                  </a>
                )}
              </TrackVisibility>
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    style={{ textDecoration: "none" }}
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    href="https://www.mypropertylisting.co.uk/"
                    target="_blank"
                  >
                    <RiExternalLinkFill
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    PREVIEW
                  </a>
                )}
              </TrackVisibility>
            </div>
          </Col>

          {/* Project 4: My Bags */}
          <Col xs={6} sm={6} md={4} xl={4} className=" divImage">
            <Row>
              <h6>Eon-Operations</h6>
            </Row>
            <a
              href="https://www.eon.com/en/about-us.html"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <div class="imageContainer">
                <LazyLoadedImage src={n28} alt="Description" />
              </div>
            </a>
            <div className="detailIconDiv">
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    style={{ textDecoration: "none" }}
                    // href="https://github.com/Sumair10/ecommerce"
                    target="_blank"
                  >
                    <FaGithub
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    PRIVATE
                  </a>
                )}
              </TrackVisibility>
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    style={{ textDecoration: "none" }}
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    href="https://www.eon.com/en/about-us.html"
                    target="_blank"
                  >
                    <RiExternalLinkFill
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    PREVIEW
                  </a>
                )}
              </TrackVisibility>
            </div>
          </Col>

          {/* Project 5: Hoo Bank */}
          <Col xs={6} sm={6} md={4} xl={4} className=" divImage">
            <Row>
              <h6>REAL ESTATE</h6>
            </Row>
            <a
              href="https://fsbo.com/"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <div class="imageContainer">
                <LazyLoadedImage src={n31} alt="Description" />
              </div>
            </a>
            <div className="detailIconDiv">
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    style={{ textDecoration: "none" }}
                    target="_blank"
                    // href="https://github.com/Sumair10/hoo-bank-app"
                  >
                    <FaGithub
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    PRIVATE
                  </a>
                )}
              </TrackVisibility>
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    style={{ textDecoration: "none" }}
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    href="https://fsbo.com/"
                    target="_blank"
                  >
                    <RiExternalLinkFill
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    PREVIEW
                  </a>
                )}
              </TrackVisibility>
            </div>
          </Col>

          {/* Project 6: Red Store */}
          <Col xs={6} sm={6} md={4} xl={4} className=" divImage">
            <Row>
              <h6>Quick Bit</h6>
            </Row>
            <a
              href="https://qb-europe.com/int/en-us/"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <div class="imageContainer">
                <LazyLoadedImage src={n30} alt="Description" />
              </div>
            </a>
            <div className="detailIconDiv">
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    style={{ textDecoration: "none" }}
                    // href="https://github.com/Sumair10/RedStore-website"
                    target="_blank"
                  >
                    <FaGithub
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    Private
                  </a>
                )}
              </TrackVisibility>
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    style={{ textDecoration: "none" }}
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    href="https://qb-europe.com/int/en-us/"
                    target="_blank"
                  >
                    <RiExternalLinkFill
                      style={{ marginRight: "5px", fontSize: "15px" }}
                    />{" "}
                    PREVIEW
                  </a>
                )}
              </TrackVisibility>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};